import { render, staticRenderFns } from "./CourseDetailDialog.vue?vue&type=template&id=88a908e2&scoped=true"
import script from "./CourseDetailDialog.vue?vue&type=script&lang=js"
export * from "./CourseDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./CourseDetailDialog.vue?vue&type=style&index=0&id=88a908e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a908e2",
  null
  
)

export default component.exports